import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import ContentHeader from 'component/utils/ContentHeader'
import StockAdjustment from 'component/report/stockAdjustment/StockAdjustment'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { accessMenus } from '../../../actions/menu'

class StockAdjustmentContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    accessMenus: PropTypes.func,
    auth: PropTypes.object,
    cdMenuChild: PropTypes.number,
  }

  render() {
    const {
      translate,
      accessMenus,
      cdMenuChild,
      auth: { user },
    } = this.props

    return (
      <section>
        <ContentHeader>
          {translate('stockAdjustment.report.title')}
        </ContentHeader>

        <StockAdjustment
          translate={translate}
          accessMenus={accessMenus}
          cdMenuChild={cdMenuChild}
          user={user}
        />
      </section>
    )
  }
}

const mapStateToProps = (state) => ({
  menu: state.menuReducer.menu,
  selectedMenu: state.menuReducer.selectedMenu,
})

/* istanbul ignore next */
export const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ accessMenus }, dispatch)

/*
 * Connects component to I18next
 */
const StockAdjustmentTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(StockAdjustmentContainer)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StockAdjustmentTranslated)

/*
 * Exports as component
 */
export { StockAdjustmentContainer }
